var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[[_c('v-card',{staticClass:"RiyoushaBox"},[_c('v-card-text',[_vm._v(" aiueo ")])],1)],[_c('v-card',{staticClass:"RiyoushaBox"},[_c('v-card-text',[_vm._v(" kakikukeko ")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }